/** @format */

import * as React from 'react';

export const IconHit = () => {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle cx="10" cy="10" r="8" fill="#88AA2A" />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M7.97936 6H10.0957C11.0788 6 11.8068 6.19795 12.2795 6.59384C12.7599 6.98973 13 7.56489 13 8.31933C13 8.82726 12.8837 9.26424 12.651 9.63025C12.4184 9.9888 12.0732 10.2652 11.6154 10.4594C11.1651 10.6536 10.606 10.7507 9.93809 10.7507H9.57786H8.9925V11.7479H10.8499V12.4762H8.9925V14H7.97936V12.4762H7V11.7479H7.97936V10.7507H7V9.89916H7.97936V6ZM10.9512 9.7535C10.636 9.85061 10.2495 9.89916 9.79174 9.89916H8.9925V6.85154H10.0056C10.6735 6.85154 11.1651 6.97479 11.4803 7.22129C11.7955 7.46779 11.9531 7.845 11.9531 8.35294C11.9531 8.74136 11.8668 9.04762 11.6942 9.27171C11.5216 9.4958 11.2739 9.6564 10.9512 9.7535Z"
        fill="white"
      />
    </svg>
  );
};
